/**
 * PV Quiz Viking - Review Photos (Screen 14)
 * Expands the clamped review text when "Read More" is clicked, and drives
 * the mobile prev/next arrows for the horizontal scroll-snap carousel
 * (grid takes over at 768px, where the arrows are hidden by CSS).
 */

(function () {
  'use strict';

  document.querySelectorAll('.pv-quiz-review-photo__read-more').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var wrap = btn.closest('.pv-quiz-review-photo__text-wrap');
      if (!wrap) return;
      var expanded = wrap.classList.toggle('is-expanded');
      btn.textContent = expanded ? 'Read Less' : 'Read More →';
    });
  });

  document.querySelectorAll('.pv-quiz-review-photos-nav').forEach(function (nav) {
    var track = nav.previousElementSibling;
    if (!track || !track.classList.contains('pv-quiz-review-photos')) return;

    // v2 (pv-long-blocks review_photos block, Figma node 6203:25110): the
    // carousel stays a horizontal scroll track past 768px too, so the
    // arrows are shown/hidden by actual overflow instead of the legacy
    // nav's viewport-only CSS. Legacy markup has neither class, so it
    // keeps its original mobile-only nav untouched.
    var isCarousel = nav.classList.contains('pv-quiz-review-photos-nav--v2');

    var prevBtn = nav.querySelector('[data-scroll-prev]');
    var nextBtn = nav.querySelector('[data-scroll-next]');

    function cardStep() {
      var card = track.querySelector('.pv-quiz-review-photo');
      if (!card) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function maxScroll() {
      var cards = track.querySelectorAll('.pv-quiz-review-photo');
      if (!cards.length) return track.scrollWidth - track.clientWidth;
      var lastCard = cards[cards.length - 1];
      var offset = lastCard.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft;
      return Math.min(offset, track.scrollWidth - track.clientWidth);
    }

    function updateButtons() {
      var max = maxScroll();
      prevBtn.disabled = track.scrollLeft <= 1;
      nextBtn.disabled = track.scrollLeft >= max - 1;
    }

    function updateOverflow() {
      var overflowing = track.scrollWidth > track.clientWidth + 1;
      nav.classList.toggle('is-visible', overflowing);
    }

    function collapseExpanded() {
      track.querySelectorAll('.pv-quiz-review-photo__text-wrap.is-expanded').forEach(function (wrap) {
        wrap.classList.remove('is-expanded');
        var btn = wrap.querySelector('.pv-quiz-review-photo__read-more');
        if (btn) btn.textContent = 'Read More →';
      });
    }

    prevBtn.addEventListener('click', function () {
      collapseExpanded();
      track.scrollBy({ left: -cardStep(), behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', function () {
      collapseExpanded();
      track.scrollBy({ left: cardStep(), behavior: 'smooth' });
    });

    track.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons);
    updateButtons();

    if (isCarousel) {
      window.addEventListener('resize', updateOverflow);
      updateOverflow();
    }
  });
})();
